export const colors = {
  primary: {
    0: '#FBFDFF',
    50: '#F1F7FE',
    100: '#E1EEFD',
    200: '#BCDCFB',
    300: '#81C0F8',
    400: '#3FA0F1',
    500: '#147BD1',
    600: '#096EC3',
    700: '#08529C',
    800: '#0B4781',
    900: '#0F3C6B',
    950: '#0A2647',
    brand: '#2048FF',
    title: '#001F6C',
  },
  secondary: {
    0: '#FFFFFF',
    50: '#FFF9F0',
    100: '#FEF3E0',
    200: '#F8DFB0',
    300: '#F0C77C',
    400: '#E7B85F',
    500: '#DDB677',
    600: '#C7974E',
    700: '#A27030',
    800: '#71441B',
    900: '#40230C',
    950: '#1E1006',
  },
  tertiary: {
    0: '#FFFFFF',
    50: '#F5F6FF',
    100: '#E6E8FF',
    200: '#C2C6FF',
    300: '#8F97FF',
    400: '#5C67FF',
    500: '#000435',
    600: '#00032B',
    700: '#00021E',
    800: '#000115',
    900: '#00000A',
    950: '#000005',
  },
  typography: {
    0: '#FEFEFF',
    50: '#F9FAFB',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#111827',
    950: '#000435',
  },
  background: {
    0: '#FFFFFF',
    50: '#FAFBFC',
    100: '#F5F6FA',
    200: '#EDF0F5',
    300: '#E3E6EC',
    400: '#D4D8E0',
    500: '#BDC3CE',
    600: '#989EAA',
    700: '#6D7380',
    800: '#404552',
    900: '#272625',
    950: '#1B1F2C',
    muted: '#F7F8F7',
    neutral: '#F5F5F5',
    light: '#FBFBFB',
  },
  border: {
    0: '#FDFEFE',
    50: '#F9FAFB',
    100: '#F0F2F5',
    200: '#E2E5EA',
    300: '#D3D7DE',
    400: '#BFC4CD',
    500: '#A6ACB7',
    600: '#8A909C',
    700: '#6A707E',
    800: '#494E5D',
    900: '#252A39',
    950: '#000435',
  },
  success: {
    0: '#FFFFFF',
    50: '#ECFDF5',
    100: '#D1FAE5',
    200: '#A7F3D0',
    300: '#6EE7B7',
    400: '#34D399',
    500: '#10B981',
    600: '#059669',
    700: '#047857',
    800: '#065F46',
    900: '#064E3B',
    950: '#022C22',
    background: '#EDFCF2',
  },
  error: {
    0: '#FFFFFF',
    50: '#FEF2F2',
    100: '#FEE2E2',
    200: '#FECACA',
    300: '#FCA5A5',
    400: '#F87171',
    500: '#EF4444',
    600: '#DC2626',
    700: '#B91C1C',
    800: '#991B1B',
    900: '#7F1D1D',
    950: '#450A0A',
    background: '#FEF1F1',
  },
  warning: {
    0: '#FFFFFF',
    50: '#FFFBEB',
    100: '#FEF3C7',
    200: '#FDE68A',
    300: '#FCD34D',
    400: '#FBBF24',
    500: '#F59E0B',
    600: '#D97706',
    700: '#B45309',
    800: '#92400E',
    900: '#78350F',
    950: '#451A03',
    background: '#FFF3EA',
  },
  info: {
    0: '#FFFFFF',
    50: '#EFF6FF',
    100: '#DBEAFE',
    200: '#BFDBFE',
    300: '#93C5FD',
    400: '#60A5FA',
    500: '#3B82F6',
    600: '#2563EB',
    700: '#1D4ED8',
    800: '#1E40AF',
    900: '#1E3A8A',
    950: '#032638',
    background: '#EBF8FE',
  },
  indicator: {
    primary: '#000435',
    info: '#3B82F6',
    error: '#EF4444',
    warning: '#F59E0B',
  },
  accent: {
    featured: '#0C34EC',
    featuredDark: '#0020B2',
    featuredLight: '#1E4AFF',
  },
  profile: {
    logoutIconBg: '#E7EEFF',
  },
} as const;

export type ColorToken = typeof colors;
export type ColorCategory = keyof typeof colors;

